import { useMemo } from "react";
import { selectAuth } from "store/slices";
// import useDispatch from "./useDispatch";
import useSelector from "./useSelector";

import ls from "utils/secureStorage";
import configs from "config";
import { AuthPayload } from "store/slices/auth";

export function useAuth() {
  //   const isHydrated = useRef(false);
  //   const dispatch = useDispatch();
  const { payload } = useSelector(selectAuth);

  const auth: AuthPayload | null = useMemo(() => {
    const auth = ls.get(configs.AUTH_TOKEN_KEY);
    return auth ?? payload;
  }, [payload]);

  //   useEffect(() => {
  //     if ((!!auth && !!auth?.exp && Date.now() > auth.exp) || !auth?.token) dispatch(dehydrate());
  //     else if (!!auth && !isHydrated?.current) {
  //       dispatch(hydrate(auth));
  //       isHydrated.current = true;
  //     }
  //   });

  return { auth };
}
